import React from "react";

const BrandLogo = ({ height, width }) => {
  return (
    <img
      src={"/images/SpinZoneLogo.png"}
      alt="Brand Logo"
      className="brand-logo"
      height={height}
      width={width}
    />
  );
};

export default BrandLogo;
